import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-category-template',
  templateUrl: './category-template.page.html',
  styleUrls: ['./category-template.page.scss'],
})
export class CategoryTemplatePage implements OnInit {
  category: any = '';
  templates: any = [];
  constructor(
    private userServ: UserService,
    private navParams: NavParams,
    private modalCtrl: ModalController
  ) {
    if (navParams.get('templatecate')) {
      this.category = navParams.get('templatecate');
      console.log(this.category);
    }
  }

  async ngOnInit() {
    this.templates = await this.userServ.getTemplates(this.category);
    console.log(this.templates);
  }
  async closeModal() {
    await this.modalCtrl.dismiss({});
  }
  async templatedata(data: any) {
    await this.modalCtrl.dismiss({ data });
  }
}
